import { render, staticRenderFns } from "./request-history.vue?vue&type=template&id=d944f59c&"
import script from "./request-history.vue?vue&type=script&lang=js&"
export * from "./request-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports